/* Tells whether an offer request covers a single order or a recurring series. */
export enum OfferRequestOrderType {
	Unknown = 0,
	/** One delivery of the requested quantity. */
	OneTime = 1,
	/** The same parts are called off repeatedly over a period of months. */
	Recurring = 2,
}
